module.exports = __webpack_public_path__ + "static/media/malachi-lily.0ce85ea3.md";